module.exports = __webpack_public_path__ + "assets/instagram-27ff10.svg";